import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { routes } from 'constants/config';
import * as assignmentsSelectors from 'selectors/learn/assignments';
import * as contentsSelectors from 'selectors/learn/contents';
import { hasGlobalFeature } from 'selectors';
import NavLinkProvider from './NavLinkProvider';

// We default to routes.LEARN if no matches are found
const isHomeActive = (match, location) =>
  (match === null && location.pathname === '/') ||
  (match !== null && match.url === routes.LEARN);

const LearnDashboardSidebar = ({
  hasAssignments,
  hasEvents,
  hasLibraryContents,
  hasStartedAny,
  features,
}) => (
  <NavLinkProvider>
    {Link => (
      <div className="DashboardSidebar">
        <div className="DashboardSidebar-group">
          <h2 className="DashboardSidebar-header">
            {t('learn.sidebar.headers.learn')}
          </h2>
          <Link
            to={routes.LEARN}
            exact
            isActive={isHomeActive}
            className="DashboardSidebar-link"
          >
            {t('learn.sidebar.my_learning_content')}
          </Link>
          <Link
            className="DashboardSidebar-link"
            to={
              features.changeAssignmentsToResources
                ? routes.LEARN_RESOURCES
                : routes.LEARN_ASSIGNMENTS
            }
            if={hasLibraryContents && hasAssignments}
          >
            {features.changeAssignmentsToResources
              ? t('resources.title')
              : t('learn.sidebar.assignments')}
          </Link>
          <Link
            to={routes.LEARN_HISTORY}
            if={hasStartedAny}
            className="DashboardSidebar-link"
          >
            {t('learn.sidebar.history')}
          </Link>
          {features.eventsDashboard && hasEvents && (
            <a
              className="DashboardSidebar-link"
              href={routes.IN_PERSON_TRAINING.EVENTS_DASHBOARD}
            >
              {t('learn.sidebar.my_training_events')}
            </a>
          )}
        </div>
        <div className="DashboardSidebar-group">
          {features.onDemandPractice && (
            <>
              <h2 className="DashboardSidebar-header">
                {t('learn.sidebar.headers.practice')}
              </h2>
              <a
                className="DashboardSidebar-link"
                href={routes.ON_DEMAND_PRACTICE.LEARNING.INDEX(1)}
              >
                {t('learn.sidebar.on_demand_practice')}
              </a>
            </>
          )}
        </div>
      </div>
    )}
  </NavLinkProvider>
);

const mapStateToProps = state => ({
  hasAssignments: assignmentsSelectors.hasAssignments(state),
  hasLibraryContents: contentsSelectors.hasLibraryContents(state),
  hasStartedAny: contentsSelectors.hasStartedAny(state),
  hasEvents: !!state.data.events.count,
  features: {
    eventsDashboard: hasGlobalFeature(state, 'training_events'),
    onDemandPractice: hasGlobalFeature(state, 'on_demand_practice'),
    changeAssignmentsToResources: hasGlobalFeature(
      state,
      'change_assignments_to_resources',
    ),
  },
});

export default withRouter(connect(mapStateToProps)(LearnDashboardSidebar));
